import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import './BottomBar.css'
import home_f from '../../img/bottombar/home.svg'
import calendar_f from '../../img/bottombar/calendar.svg'
import notification_f from '../../img/bottombar/inbox.svg'
import user_f from '../../img/bottombar/user.svg'
import home_l from '../../img/bottombar/home_l.svg'
import calendar_l from '../../img/bottombar/calendar_l.svg'
import notification_l from '../../img/bottombar/inbox_l.svg'
import user_l from '../../img/bottombar/user_l.svg'

class BottomBar extends Component {
	constructor(props) {
		super(props)
		this.state = {
			bottomHighlight: this.props.bottomHighlight,
			notifications: this.props.notifications,
			conversations: this.props.conversations || null,
		}
	}

	componentDidMount() {
		this.loadNotifications()
		this.loadConversations()
	}

	componentDidUpdate(prevProps) {
		if (prevProps.bottomHighlight !== this.props.bottomHighlight)
			this.setState({ bottomHighlight: this.props.bottomHighlight })
		if (prevProps.notifications !== this.props.notifications)
			this.setState({ notifications: this.props.notifications })
		if (prevProps.conversations !== this.props.conversations)
			this.setState({ conversations: this.props.conversations })
		this.loadConversations()
	}

	loadNotifications = () => {
		if (this.props.notifications)
			this.setState({ notifications: this.props.notifications })
		else
			this.props.fetchNotifications()
	}

	loadConversations = () => {
		const showMessages = this.props.user && this.props.user._id && this.props.features === 'premium' && this.props.config_messages && this.props.config_messages.active === true
		if (showMessages && this.props.conversations === null)
			this.props.fetchConversationsByUser(this.props.user._id)
	}

	render() {
		const lang_assets = this.props.lang_assets.bottomBar
		const highlight = this.state.bottomHighlight
		const notifications = this.state.notifications
		let home = home_f
		let calendar = calendar_f
		let notification = notification_f
		let user = user_f
		let textHome = 'text-gray-400'
		let textCalendar = 'text-gray-400'
		let textNotification = 'text-gray-400'
		let textUser = 'text-gray-400'
		if (highlight === 'home')
		{
			home = home_l
			textHome = 'text-gray-600'
		}
		else if (highlight === 'calendar')
		{
			calendar = calendar_l
			textCalendar = 'text-gray-600'
		}
		else if (highlight === 'notification')
		{
			notification = notification_l
			textNotification = 'text-gray-600'
		}
		else if (highlight === 'profile')
		{
			user = user_l
			textUser = 'text-gray-600'
		}
		const showMessages = this.props.user && this.props.user._id && this.props.features === 'premium' && this.props.config_messages && this.props.config_messages.active === true
		const conversations = this.props.conversations
		let unread = false
		if (notifications !== null)
		{
			for (let i = 0; i < notifications.length; i++)
			{
				if (notifications[i].read === false)
				{
					unread = true
					break
				}
			}
		}
		if (unread === false && showMessages === true && conversations !== null)
		{
			for (let i = 0; i < conversations.length; i++)
			{
				if (conversations[i].read_guest === false)
				{
					unread = true
					break
				}
			}
		}
		let dot = null
		if (unread === true)
			dot = (
				<div style={{
					position: 'absolute',
					top: '-3px',
					right: '-3px',
					width: '10px',
					height: '10px',
					borderRadius: '50%',
					backgroundColor: '#EF4444',
					border: '2px solid #F6F8FA',
				}} />
			)
		const path_home = '/'
		const path_activities = this.props.lang_assets.paths.activities
		const path_notifications = this.props.lang_assets.paths.notifications
		const path_account = this.props.lang_assets.paths.account
		return (
			<div className="BottomBar flex">
				<motion.div className="flex-1 flex flex-col items-center justify-center" whileTap={{ scale: 0.88 }}>
					<Link to={path_home} className="flex flex-col items-center">
						<img src={home} alt={lang_assets.home} className="w-6 h-6" />
						<p className={`text-xs mt-1 ${textHome}`}>{lang_assets.home}</p>
					</Link>
				</motion.div>
				<motion.div className="flex-1 flex flex-col items-center justify-center" whileTap={{ scale: 0.88 }}>
					<Link to={path_activities} className="flex flex-col items-center">
						<img src={calendar} alt={lang_assets.activities} className="w-6 h-6" />
						<p className={`text-xs mt-1 ${textCalendar}`}>{lang_assets.activities}</p>
					</Link>
				</motion.div>
				<motion.div className="flex-1 flex flex-col items-center justify-center relative" whileTap={{ scale: 0.88 }}>
					<Link to={path_notifications} className="flex flex-col items-center">
						<div style={{ position: 'relative', display: 'inline-flex' }}>
							<img src={notification} alt={lang_assets.notifications} className="w-6 h-6" />
							{dot}
						</div>
						<p className={`text-xs mt-1 ${textNotification}`}>{lang_assets.notifications}</p>
					</Link>
				</motion.div>
				<motion.div className="flex-1 flex flex-col items-center justify-center" whileTap={{ scale: 0.88 }}>
					<Link to={path_account} className="flex flex-col items-center">
						<img src={user} alt={lang_assets.user} className="w-6 h-6" />
						<p className={`text-xs mt-1 ${textUser}`}>{lang_assets.user}</p>
					</Link>
				</motion.div>
			</div>
		)
	}
}

export default BottomBar
